(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rdtn-desktop-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('.rdtn-desktop-nav details[open]').forEach(details => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.rdtn-desktop-nav details[open]').forEach(details => {
      details.removeAttribute('open');
      details.querySelector('summary')?.focus();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rdtn-display-currency"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.RdtnCurrencyDisplay) return;
  const preferenceKey = 'rdtn-display-currency-v1';
  const countryCurrencies = {"AC":"SHP","AD":"EUR","AE":"AED","AF":"AFN","AG":"XCD","AI":"XCD","AL":"ALL","AM":"AMD","AO":"AOA","AR":"ARS","AS":"USD","AT":"EUR","AU":"AUD","AW":"AWG","AX":"EUR","AZ":"AZN","BA":"BAM","BB":"BBD","BD":"BDT","BE":"EUR","BF":"XOF","BG":"EUR","BH":"BHD","BI":"BIF","BJ":"XOF","BL":"EUR","BM":"BMD","BN":"BND","BO":"BOB","BQ":"USD","BR":"BRL","BS":"BSD","BT":"BTN","BV":"NOK","BW":"BWP","BY":"BYN","BZ":"BZD","CA":"CAD","CC":"AUD","CD":"CDF","CF":"XAF","CG":"XAF","CH":"CHF","CI":"XOF","CK":"NZD","CL":"CLP","CM":"XAF","CN":"CNY","CO":"COP","CR":"CRC","CU":"CUP","CV":"CVE","CW":"XCG","CX":"AUD","CY":"EUR","CZ":"CZK","DE":"EUR","DG":"USD","DJ":"DJF","DK":"DKK","DM":"XCD","DO":"DOP","DZ":"DZD","EA":"EUR","EC":"USD","EE":"EUR","EG":"EGP","EH":"MAD","ER":"ERN","ES":"EUR","ET":"ETB","EU":"EUR","FI":"EUR","FJ":"FJD","FK":"FKP","FM":"USD","FO":"DKK","FR":"EUR","GA":"XAF","GB":"GBP","GD":"XCD","GE":"GEL","GF":"EUR","GG":"GBP","GH":"GHS","GI":"GIP","GL":"DKK","GM":"GMD","GN":"GNF","GP":"EUR","GQ":"XAF","GR":"EUR","GS":"GBP","GT":"GTQ","GU":"USD","GW":"XOF","GY":"GYD","HK":"HKD","HM":"AUD","HN":"HNL","HR":"EUR","HT":"HTG","HU":"HUF","IC":"EUR","ID":"IDR","IE":"EUR","IL":"ILS","IM":"GBP","IN":"INR","IO":"USD","IQ":"IQD","IR":"IRR","IS":"ISK","IT":"EUR","JE":"GBP","JM":"JMD","JO":"JOD","JP":"JPY","KE":"KES","KG":"KGS","KH":"KHR","KI":"AUD","KM":"KMF","KN":"XCD","KP":"KPW","KR":"KRW","KW":"KWD","KY":"KYD","KZ":"KZT","LA":"LAK","LB":"LBP","LC":"XCD","LI":"CHF","LK":"LKR","LR":"LRD","LS":"ZAR","LT":"EUR","LU":"EUR","LV":"EUR","LY":"LYD","MA":"MAD","MC":"EUR","MD":"MDL","ME":"EUR","MF":"EUR","MG":"MGA","MH":"USD","MK":"MKD","ML":"XOF","MM":"MMK","MN":"MNT","MO":"MOP","MP":"USD","MQ":"EUR","MR":"MRU","MS":"XCD","MT":"EUR","MU":"MUR","MV":"MVR","MW":"MWK","MX":"MXN","MY":"MYR","MZ":"MZN","NA":"NAD","NC":"XPF","NE":"XOF","NF":"AUD","NG":"NGN","NI":"NIO","NL":"EUR","NO":"NOK","NP":"NPR","NR":"AUD","NU":"NZD","NZ":"NZD","OM":"OMR","PA":"PAB","PE":"PEN","PF":"XPF","PG":"PGK","PH":"PHP","PK":"PKR","PL":"PLN","PM":"EUR","PN":"NZD","PR":"USD","PS":"ILS","PT":"EUR","PW":"USD","PY":"PYG","QA":"QAR","RE":"EUR","RO":"RON","RS":"RSD","RU":"RUB","RW":"RWF","SA":"SAR","SB":"SBD","SC":"SCR","SD":"SDG","SE":"SEK","SG":"SGD","SH":"SHP","SI":"EUR","SJ":"NOK","SK":"EUR","SL":"SLE","SM":"EUR","SN":"XOF","SO":"SOS","SR":"SRD","SS":"SSP","ST":"STN","SV":"USD","SX":"XCG","SY":"SYP","SZ":"SZL","TA":"GBP","TC":"USD","TD":"XAF","TF":"EUR","TG":"XOF","TH":"THB","TJ":"TJS","TK":"NZD","TL":"USD","TM":"TMT","TN":"TND","TO":"TOP","TR":"TRY","TT":"TTD","TV":"AUD","TW":"TWD","TZ":"TZS","UA":"UAH","UG":"UGX","UM":"USD","US":"USD","UY":"UYU","UZ":"UZS","VA":"EUR","VC":"XCD","VE":"VES","VG":"USD","VI":"USD","VN":"VND","VU":"VUV","WF":"XPF","WS":"WST","XK":"EUR","YE":"YER","YT":"EUR","ZA":"ZAR","ZM":"ZMW","ZW":"ZWG"};
  const messages = {
    ar: {"apply":"تطبيق","label":"عملة العرض (تقديرية)","auto":"تلقائي","note":"مبالغ تقريبية وفق أسعار صرف ⁦Shopify⁩. يُحصّل الدفع بعملة ⁦USD⁩؛ وقد يختلف سعر الصرف لدى بنكك.","failure":"التقديرات غير متاحة. الأسعار والدفع بعملة ⁦USD⁩.","short":"تقريبًا","checkout":"الدفع: ⁦USD⁩"},
    pl: {"apply":"Zastosuj","label":"Waluta (ceny orientacyjne)","auto":"Automatycznie","note":"Orientacyjne kwoty według kursów Shopify. Płatność jest pobierana w USD; kurs Twojego banku może się różnić.","failure":"Szacunkowe przeliczenie jest niedostępne. Ceny i płatność są w USD.","short":"Około","checkout":"Płatność: USD"},
    ko: { apply: '적용', label: '표시 통화 (예상 금액)', auto: '자동', note: 'Shopify 환율을 기준으로 한 예상 금액입니다. 결제는 USD로 청구되며 은행 적용 환율은 다를 수 있습니다.', failure: '예상 환율을 불러올 수 없습니다. 가격과 결제 금액은 USD로 표시됩니다.', short: '예상 금액', checkout: '결제: USD' },
    en: { apply: 'Apply', label: 'Display currency (estimate)', auto: 'Automatic', note: 'Approximate Shopify-rate estimates. Checkout is charged in USD; your bank rate may differ.', failure: 'Estimates unavailable. Prices and checkout are in USD.', short: 'Approximate', checkout: 'Checkout: USD' },
    'zh-tw': { apply: '套用', label: '顯示幣別（估價）', auto: '依地區自動選擇', note: '依 Shopify 匯率換算的參考估價；結帳仍以美元 USD 扣款，銀行實際匯率可能不同。', failure: '暫時無法取得估算匯率，價格與結帳均顯示美元 USD。', short: '約', checkout: '結帳：USD' },
    es: { apply: 'Aplicar', label: 'Moneda de visualización (estimada)', auto: 'Automática', note: 'Estimaciones con tipos de Shopify. El cobro se realiza en USD; el tipo de tu banco puede variar.', failure: 'Estimaciones no disponibles. Precios y pago en USD.', short: 'Aproximado', checkout: 'Pago: USD' },
    ja: { apply: '適用', label: '表示通貨（参考価格）', auto: '地域に合わせて自動選択', note: 'Shopifyの為替レートによる概算です。決済はUSDで行われ、銀行の適用レートは異なる場合があります。', failure: '概算レートを取得できません。価格と決済通貨はUSDです。', short: '概算', checkout: '決済：USD' },
    fr: { apply: 'Appliquer', label: 'Devise affichée (estimation)', auto: 'Automatique', note: 'Estimations selon les taux Shopify. Le paiement reste en USD ; le taux de votre banque peut varier.', failure: 'Estimations indisponibles. Prix et paiement en USD.', short: 'Estimation', checkout: 'Paiement : USD' },
    de: { apply: 'Anwenden', label: 'Anzeigewährung (Schätzung)', auto: 'Automatisch', note: 'Ungefähre Beträge mit Shopify-Wechselkursen. Zahlung in USD; der Bankkurs kann abweichen.', failure: 'Schätzungen nicht verfügbar. Preise und Zahlung in USD.', short: 'Ungefähr', checkout: 'Zahlung: USD' }
  };
  let chosen = '';
  try { chosen = localStorage.getItem(preferenceKey) || ''; } catch (_) {}
  let pending = false;
  const generated = new WeakMap();
  const validCents = value => value !== null && value !== '' && /^-?\d+$/.test(value) && Number.isSafeInteger(Number(value));
  const state = () => document.getElementById('RdtnCurrencyState');
  const dictionary = () => messages[(state()?.dataset.language || document.documentElement.lang || 'en').toLowerCase()] || messages.en;
  const ratesReady = () => typeof window.Currency?.convert === 'function' && Number.isFinite(window.Currency?.rates?.USD) && window.Currency.rates.USD > 0;
  const supports = code => /^[A-Z]{3}$/.test(code) && ratesReady() && Number.isFinite(window.Currency.rates[code]) && window.Currency.rates[code] > 0;
  const mappedCurrency = () => countryCurrencies[state()?.dataset.country] || 'USD';
  const settlementIsUSD = () => state()?.dataset.storeCurrency === 'USD' && state()?.dataset.presentmentCurrency === 'USD';
  const displayCurrency = () => {
    const requested = chosen || mappedCurrency();
    return settlementIsUSD() && supports(requested) ? requested : 'USD';
  };
  const format = (cents, currency) => {
    const amount = window.Currency.convert(Number(cents), 'USD', currency) / 100;
    if (!Number.isFinite(amount)) return null;
    const locale = state()?.dataset.language || document.documentElement.lang || 'en';
    return new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'code' }).format(amount);
  };
  const refresh = () => {
    pending = false;
    const config = state();
    if (!config) return;
    const text = dictionary();
    const available = ratesReady() && settlementIsUSD();
    const currency = displayCurrency();
    const selector = document.getElementById('RdtnDisplayCurrency');
    const applyButton = document.querySelector('[data-rdtn-locale-apply]');
    if (applyButton && applyButton.textContent !== text.apply) {
      applyButton.textContent = text.apply;
      applyButton.setAttribute('aria-label', text.apply);
    }
    if (selector && !selector.dataset.initialized) {
      selector.dataset.initialized = 'true';
      selector.addEventListener('change', () => {
        chosen = selector.value === 'auto' ? '' : selector.value;
        try { if (chosen) localStorage.setItem(preferenceKey, chosen); else localStorage.removeItem(preferenceKey); } catch (_) {}
        refresh();
      });
    }
    if (selector) {
      const label = document.querySelector('label[for="RdtnDisplayCurrency"]');
      if (label && label.textContent !== text.label) label.textContent = text.label;
      const fingerprint = available ? config.dataset.language + ':' + config.dataset.country + ':' + Object.keys(window.Currency.rates).sort().join(',') : 'USD';
      if (selector.dataset.options !== fingerprint) {
        selector.replaceChildren();
        const automatic = document.createElement('option');
        automatic.value = 'auto';
        automatic.textContent = text.auto + ' (' + (available && supports(mappedCurrency()) ? mappedCurrency() : 'USD') + ')';
        selector.append(automatic);
        const codes = available ? [...new Set(['USD', ...Object.values(countryCurrencies)])].filter(supports).sort() : ['USD'];
        for (const code of codes) {
          const option = document.createElement('option');
          option.value = code;
          option.textContent = code;
          selector.append(option);
        }
        selector.dataset.options = fingerprint;
      }
      const desired = chosen && [...selector.options].some(option => option.value === chosen) ? chosen : 'auto';
      if (selector.value !== desired) selector.value = desired;
      selector.disabled = !available;
      selector.closest('[data-rdtn-fx-field]').hidden = false;
    }
    for (const note of document.querySelectorAll('[data-rdtn-fx-note]')) {
      const copy = available ? text.note : text.failure;
      if (note.textContent !== copy) note.textContent = copy;
      note.hidden = false;
    }
    const badge = document.querySelector('[data-rdtn-current-currency]');
    if (badge) {
      const label = currency === 'USD' ? 'USD' : '≈' + currency;
      if (badge.textContent !== label) badge.textContent = label;
      badge.title = text.note;
      const summary = badge.closest('summary');
      if (summary) {
        if (!summary.dataset.baseLabel) summary.dataset.baseLabel = summary.getAttribute('aria-label') || '';
        summary.setAttribute('aria-label', summary.dataset.baseLabel + (currency === 'USD' ? '' : ' · ' + text.short + ' ' + currency + ' · ' + text.checkout));
      }
    }
    for (const stale of document.querySelectorAll('[data-rdtn-fx-generated]')) {
      if (!stale.previousElementSibling?.matches('[data-rdtn-usd-cents]')) stale.remove();
    }
    for (const source of document.querySelectorAll('[data-rdtn-usd-cents]')) {
      if (source.closest('script,style,template,head')) continue;
      let estimate = generated.get(source);
      if (estimate && !estimate.isConnected) estimate = null;
      if (!estimate && source.nextElementSibling?.matches('[data-rdtn-fx-generated]')) {
        estimate = source.nextElementSibling;
        generated.set(source, estimate);
      }
      const cents = source.getAttribute('data-rdtn-usd-cents');
      const max = source.getAttribute('data-rdtn-usd-max-cents');
      let value = null;
      if (currency !== 'USD' && validCents(cents) && (max === null || validCents(max))) {
        try {
          value = format(cents, currency);
          if (max !== null) {
            const end = format(max, currency);
            value = value && end ? value + ' – ' + end : null;
          }
        } catch (_) { value = null; }
      }
      if (!value) {
        if (estimate) estimate.remove();
        generated.delete(source);
        continue;
      }
      if (!estimate) {
        estimate = document.createElement('small');
        estimate.className = 'rdtn-fx-estimate';
        estimate.setAttribute('data-rdtn-fx-generated', 'true');
        source.insertAdjacentElement('afterend', estimate);
        generated.set(source, estimate);
      }
      const label = '≈ ' + value;
      if (estimate.textContent !== label) estimate.textContent = label;
      estimate.title = text.note;
      estimate.setAttribute('aria-label', text.short + ' ' + value + '. ' + text.checkout);
    }
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(refresh); } };
  window.RdtnCurrencyDisplay = { refresh, displayCurrency, mappedCurrency };
  const start = () => {
    refresh();
    document.getElementById('RdtnCurrencyRates')?.addEventListener('load', schedule, { once: true });
    document.getElementById('RdtnCurrencyRates')?.addEventListener('error', schedule, { once: true });
    const observer = new MutationObserver(records => {
      if (records.some(record => {
        if (record.target.nodeType === 1 && record.target.closest('[data-rdtn-fx-generated], [data-rdtn-fx-note], #RdtnDisplayCurrency')) return false;
        if (record.target.parentElement?.closest('[data-rdtn-fx-generated], [data-rdtn-fx-note], #RdtnDisplayCurrency')) return false;
        return record.type === 'attributes' || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && !node.matches('[data-rdtn-fx-generated]'));
      })) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-rdtn-usd-cents', 'data-rdtn-usd-max-cents', 'data-country', 'data-language'] });
    document.addEventListener('shopify:section:load', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rdtn-localization-bar"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    const root = document.querySelector('.rdtn-localization');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form');
    const country = form.querySelector('[name="country_code"]');
    const language = form.querySelector('[name="language_code"]');
    const available = Array.from(language.options, option => option.value);
    const matched = value => available.find(code => code.toLowerCase() === value.toLowerCase());
    const countryLanguageGroups = {
      'zh-TW': 'HK MO TW'.split(' '),
      'ja': 'JP'.split(' '),
      'ko': 'KR'.split(' '),
      'pl': 'PL'.split(' '),
      'ar': 'AE SA'.split(' '),
      'de': 'AT CH DE LI'.split(' '),
      'es': 'AD AR BO CL CO CR DO EC ES GQ GT HN MX NI PA PE PY SV UY VE'.split(' '),
      'fr': 'BE BF BI BJ BL CD CF CG CI CM DJ DZ FR GA GF GN GP HT KM LU MA MC MF MG ML MQ MR MU NC NE PF PM RE SN TD TF TG TN WF YT'.split(' ')
    };
    const countryLanguage = code => Object.keys(countryLanguageGroups).find(locale => countryLanguageGroups[locale].includes(code)) || 'en';
    const targetLanguage = code => matched(countryLanguage(code)) || matched('en');
    let manualLanguage = false;
    const preferenceKey = 'rdtn-explicit-language-v2';
    const guardKey = 'rdtn-auto-language-v2';
    let storageAvailable = true;
    let preference = '';
    try {
      preference = localStorage.getItem(preferenceKey) || '';
      sessionStorage.setItem('rdtn-localization-storage', '1');
      sessionStorage.removeItem('rdtn-localization-storage');
    } catch (_) { storageAvailable = false; }
    for (const option of country.options) {
      const flag = Array.from(option.value, letter => String.fromCodePoint(127397 + letter.charCodeAt(0))).join('');
      option.textContent = flag + ' ' + option.textContent;
    }
    country.addEventListener('change', () => {
      if (!manualLanguage) language.value = matched(preference) || targetLanguage(country.value) || language.value;
    });
    language.addEventListener('change', () => { manualLanguage = true; });
    form.addEventListener('submit', event => {
      if (event.submitter) {
        try {
          if (manualLanguage) {
            preference = language.value;
            localStorage.setItem(preferenceKey, preference);
          }
          sessionStorage.removeItem(guardKey);
        } catch (_) {}
      }
    });
    const resetLanguage = form.querySelector('[data-rdtn-language-auto]');
    if (resetLanguage) {
      resetLanguage.hidden = false;
      resetLanguage.addEventListener('click', () => {
        preference = '';
        manualLanguage = false;
        try {
          localStorage.removeItem(preferenceKey);
          sessionStorage.removeItem(guardKey);
        } catch (_) {}
        language.value = targetLanguage(country.value) || language.value;
        form.requestSubmit();
      });
    }
    document.addEventListener('click', event => { if (!root.contains(event.target)) root.open = false; });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && root.open) {
        root.open = false;
        root.querySelector('summary').focus();
      }
    });
    if (!storageAvailable || document.documentElement.hasAttribute('data-shopify-design-mode')) return;
    const localeRoot = (root.dataset.localeRoot || '/').replace(/\/+$/, '') || '/';
    if (!['/', '/en-tw', '/zh-taiwan'].includes(localeRoot)) return;
    const target = matched(preference) || targetLanguage(root.dataset.country);
    if (!target || target.toLowerCase() === root.dataset.language.toLowerCase()) return;
    const attempt = root.dataset.country + ':' + target;
    try {
      if (sessionStorage.getItem(guardKey) === attempt) return;
      sessionStorage.setItem(guardKey, attempt);
    } catch (_) { return; }
    language.value = target;
    form.requestSubmit();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
